import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";
import { KineticHeadline, Reveal } from "@/components/motion/Reveal";

export default function PageHero({ eyebrow, titleLines, subtitle, crumb }) {
  return (
    <section data-testid="page-hero" className="relative pt-36 md:pt-48 pb-16 md:pb-24 bg-paper overflow-hidden">
      {/* soft background accent */}
      <div className="pointer-events-none absolute -top-32 -right-32 w-[38rem] h-[38rem] rounded-full bg-mint/60 blur-3xl opacity-70" />
      <div className="relative max-w-[1400px] mx-auto px-6 md:px-12">
        <Reveal>
          <nav className="flex items-center gap-2 text-xs uppercase tracking-[0.18em] text-sage mb-8" data-testid="breadcrumb">
            <Link to="/" className="hover:text-brand transition-colors">Home</Link>
            <ChevronRight size={13} />
            <span className="text-brand font-semibold">{crumb}</span>
          </nav>
        </Reveal>

        {eyebrow && (
          <Reveal delay={0.05}>
            <p className="text-xs uppercase tracking-[0.22em] font-bold text-brand mb-6">{eyebrow}</p>
          </Reveal>
        )}

        <h1 className="font-display text-5xl md:text-7xl lg:text-[6vw] leading-[0.92] tracking-tight text-ink font-light max-w-5xl">
          <KineticHeadline lines={titleLines} />
        </h1>

        {subtitle && (
          <Reveal delay={0.3}>
            <p className="mt-8 text-lg md:text-xl text-sage max-w-2xl leading-relaxed">{subtitle}</p>
          </Reveal>
        )}
      </div>
    </section>
  );
}
